var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDaifukuan = function SvgDaifukuan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.298 14.042c-1.125 0-2.43 1.231-2.43 2.328v.284c0 1.097 1.375 2.314 2.43 2.314h7.201v-4.926h-7.201Zm0 6.476c-2.25 0-4.08-1.784-4.08-3.976v-.285c0-2.193 1.83-3.725 4.08-3.725h7.071c.899 0 1.631.713 1.631 1.59v4.806c0 .876-.732 1.59-1.63 1.59h-7.072Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 3.977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.488 3.105H16.82V1.56H1.488v1.545ZM21.45 7.05h1.02c.283 0 .51-.222.51-.497V4.9c0-.98-.792-1.775-1.767-1.775h-2.856v-1.35c0-.979-.763-1.775-1.7-1.775H1.7C.762 0 0 .796 0 1.776V15.562c0 3.563 2.806 6.461 6.255 6.461h14.958c.975 0 1.767-.796 1.767-1.775v-1.45a.503.503 0 0 0-.51-.497h-.51a.503.503 0 0 0-.51.498v1.752H5.737c-2.324 0-4.215-2.523-4.215-4.99V4.534H21.45v2.021c0 .275.229.497.51.497h-.51Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#333",
    cx: 16.298,
    cy: 12.512,
    r: 1
  })))));
};

export default SvgDaifukuan;